module.exports = __webpack_public_path__ + "static/img/chendongsheng.d6d4aaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/mentorTeam/images/chendongsheng.png
// module id = oE2B
// module chunks = 0